import React, { ReactElement } from 'react';

import { classNames, noop } from '@philips-emr/tws-utils';

export interface ExpanderProps {
  expanded?: boolean;
  onClick?: () => void;
}

function InformationBarExpander(props: ExpanderProps): ReactElement {
  const { expanded = false, onClick = noop } = props;

  const expanderClasses = classNames({
    'c-information-bar__expander': true,
    'is-expanded': expanded,
  });

  return (
    <div className={expanderClasses} onClick={onClick} />
  );
}

export default InformationBarExpander;
